import { labelColorAreas } from '../../../teams/components/Label/labelVariables';
import { extendColorScheme, pickValuesFromColorScheme } from '../../../colorUtils';
export default (function (siteVars) {
  return {
    colorScheme: pickValuesFromColorScheme(extendColorScheme(siteVars.colorScheme, {
      brand: {
        background: siteVars.colorScheme.brand.foreground4
      },
      red: {
        background: siteVars.colorScheme.red.foreground1
      }
    }), labelColorAreas)
  };
});
//# sourceMappingURL=labelVariables.js.map
